// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/bootstrap.min.css
// module id = a0pE
// module chunks = 12